import { render, staticRenderFns } from "./NumericInputDialog.vue?vue&type=template&id=510ea23a&scoped=true"
import script from "./NumericInputDialog.vue?vue&type=script&lang=ts"
export * from "./NumericInputDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510ea23a",
  null
  
)

export default component.exports